/**
 * Stage Slider
 * based on Flickity
 */

(function ($) {

    // Elements
    var $slider = $('.js-stage-slider'),
        sliderCell = '.js-stage-slider__cell',
        // Seconds -> Millisecond
        speed = $slider.attr('data-autoplay-speed') * 1000;

    $slider.flickity({

        cellSelector: sliderCell,
        setGallerySize: false,
        contain: true,
        imagesLoaded: true,
        pageDots: false,
        percentPosition: false,
        arrowShape: 'M62.5 0l3.6 2.1L38.7 50l27.4 47.9-3.6 2.1-28.6-50L62.5 0z',
        autoPlay: (speed > 0) ? speed : false,
        pauseAutoPlayOnHover: true

    });

})(jQuery);
